import { IdDisplay } from '../../display/IdDisplay';
import { useEditorContext } from '../EditorContext';
import { ModalEditorItemBase } from './ModalEditorItemBase';

export interface ModalIdItemProps {
    fieldKey?: string;
    required?: boolean;
    label?: string;
    labelWidth?: number;
}

export const ModalIdItem = <TFormType,>({ fieldKey = 'id', required, label, labelWidth }: ModalIdItemProps) => {
    const { form } = useEditorContext<TFormType>();
    const value = form.getValues()[fieldKey as keyof TFormType] as string | undefined;

    return (
        <ModalEditorItemBase label={label} labelWidth={labelWidth} error={undefined} required={required}>
            <IdDisplay value={value || ''} />
        </ModalEditorItemBase>
    );
};
